export function searchModal() {

    $('.searchOpen').on('click', function () {
        $('body').addClass('body-scroll-off');
        $('html').addClass('body-scroll-off');
        $('.search-modal').stop().slideDown();
    });

    $('.searchClose').on('click', function () {
        $('body').removeClass('body-scroll-off');
        $('html').removeClass('body-scroll-off');
        $('.search-modal').stop().slideUp();
    });

    $(".generalForm").on('submit', function () {
        let keyword = $(this).find("input[name='keyword']").val(),
            container = $("#generalSearchResults");
        if (keyword.length < 3) {
            container.html("Search terms must be at least 3 characters in length");
            return false;
        }
        container.css("opacity", 0.5);
        $.get("/wp-json/shamrock/v1/global/search?keyword=" + keyword, function (data) {
            let html = "";
            for (let i = 0; i < data.length; i++) {
                html += renderResult(data[i].title,data[i].desc,data[i].link);
            }
            if(!html){
                html = "No results";
            }
            container.html(html);
        }).always(function () {
            container.css("opacity", 1);
        }).fail(function (error) {
            container.html(error.responseJSON.error);
        });
        return false;
    });

    var renderResult = function (title, desc, link) {
        let linkLabel = link.replace("http://","").replace("https://","");
        return "<div class=\"item d-flex justify-content-between align-items-center\">\n" +
            "                    <div class=\"text-item\">\n" +
            "                        <h6 class=\"title color__tropical-rain-forest\">\n" +
            "                            " + title + "\n" +
            "                        </h6>\n" +
            "                        <p class=\"desc\">\n" +
            "                            " + desc + "\n" +
            "                        </p>\n" +
            "                        <p class=\"link\">\n" +
            "                            " + linkLabel + "\n" +
            "                        </p>\n" +
            "                    </div>\n" +
            "                    <div class=\"button\">\n" +
            "                        <a href=\"" + link + "\" class=\"btn btn__green\">\n" +
            "                            Go\n" +
            "                        </a>\n" +
            "                    </div>\n" +
            "                </div>";
    }
}